import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csdatatype(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# data type tutorial For Beginners</title>
 <meta name="description" content="C# data type tutorial for beginners.data type in C# is a int,float,double,short,ushort,bool,long,char etc. Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# data type,c# data type for,c# continue,data type foreach c#,c# foreach data type" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-datatypes" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Datatype</h1>
    <div className="first">
        <a href="/csharp-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 para">There are three types of c# datatypes:
</h2>
<h3 className="mt-4 mh3">1, Value Data Type<br/>
2, Pointer Data Type<br/>
3, Reference Data Type<br/>
</h3>
<p className="mt-4 para"><span className="bold">1, Value Data Type:</span>int,float,double,short,ushort,bool,long,char etc.<br/>
<span className="bold">2, pointer Data Type:</span>pointer<br/>
<span className="bold">3, Reference Data type:</span> object,class,interface,etc.
</p>

<h2 className="mt-4 mh2">There are 8 types of primitive data types in c#</h2>
<h3 className="mt-4 mh3">1, Int<br/>
2, float<br/>
3, double<br/>
4, Boolean<br/>
5, byte<br/>
6, Short<br/>
7, Char<br/>
8, Long<br/>
</h3>



<h2 className='headings'>c# Datatypes Example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-10">int </span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">=</span>
            <span className="qwerty-9"> 10</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">float </span>
            <span className="qwerty-5">num </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">1.2348f </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">double </span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">20.8456456</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">boolean </span>
            <span className="qwerty-3">b </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-5">true</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-10">/</span>
            <span className="qwerty-5">false</span>
            {"\n"}
            <span className="qwerty-5">byte </span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">10</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Short </span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">10000</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Character </span>
            <span className="qwerty-3">h </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-10">'</span>
            <span className="qwerty-3">j</span>
            <span className="qwerty-10">'</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">Long </span>
            <span className="qwerty-3">h </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">10525252272544l</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h3 className="mt-4 bold mh3">1, Integers c# data type -<br/></h3>
<p className="para mt-4">In Integers c# data type this group includes int, long, short and byte and this is a whole value number
integers include positive, negative and all type of signs but without decimal<br/>
<span className="bold pt-4">A, In Integers c# data type:</span><br/> we can store only numeric value and int data types store from -2147483648 to 2147483647.
</p>



<h2 className='headings'>Integers c# data types Example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">int </span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">=</span>
            <span className="qwerty-4"> 244565</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-10">WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-9">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">244565 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<p className="mt-4 para">
<span className="bold">B, In long C# data type:<br/></span>
a long data type is used when int can’t handle large value so the long data type in c# store value start  from -9223372036854775808 
and on 9223372036854775807 and you don’t store the large value inside long data type if you type long data type so you also write capital l like”l” after number end.
</p>


<p className="mt-4 para">
<span className="bold">C, In Short, c# data type:</span><br/>
Short c# data type is used when creates a short integer and short data type store hole number from -32768 to 32767
And short is used when you don’t need the large range number like int.

</p>



<h2 className='headings'>Short c# basic data types Example : </h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">short </span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">=</span>
            <span className="qwerty-4"> 32765</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-10">WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-9">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">32765</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<p className="mt-4 para">
<span className="bold">D, In Byte c# data type:</span><br/>
Byte c# data type is used when The smallest integer type is a byte in integer .byte can store numbers from -128 to 127
</p>
<h2 className="mt-4 ">2, Characters c# data type</h2>
<p className="mt-3 para" >a, Char c# data type is used to hold a single character, Unicode character <br/>
b, Char data type enclosed by a single quotes and Learn <a style={{textDecoration: 'none'}} target="_blank" href="https://www.codeexampler.com/csharp-for-loop">c# for loop Statement</a> with lot of Examples.
</p>



<h2 className='headings'>Char c# data types Example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">char </span>
            <span className="qwerty-4">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-4">'</span>
            <span className="qwerty-3">h</span>
            <span className="qwerty-4">'</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">char </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-9">88</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2">//</span>
            <span className="qwerty-3">code for x learn by unicode </span>
            {"\n"}
            <span className="qwerty-2">Console </span>
            <span className="qwerty-5">.WriteLine </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">Console. </span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">hX</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className='headings'>Char c# data types Example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">char </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-4">b;</span>
            {"\n"}
            <span className="qwerty-4">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-9">x</span>
            <span className="qwerty-3">'</span>
            {"\n"}
            <span className="qwerty-4">b</span>
            <span className="qwerty-2"> =(char)</span>
            <span className="qwerty-7">90</span>
            {"\n"}
            <span className="qwerty-2">Console</span>
            <span className="qwerty-10">.WriteLine </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">Console</span>
            <span className="qwerty-10">.WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">x</span>
            {"\n"}
            <span className="qwerty-5">Z</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">If you increment character in c# basic data types:
</h2>



<h2 className='headings'>Char c# data types Example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">Char </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-9">x</span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">Console</span>
            <span className="qwerty-10">.WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">a </span>
            <span className="qwerty-5">++ ;</span>
            <span className="qwerty-6">// </span>
            <span className="qwerty-4">increment </span>
            <span className="qwerty-6">a</span>
            {"\n"}
            <span className="qwerty-2">Console </span>
            <span className="qwerty-10">.WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">x</span>
            {"\n"}
            <span className="qwerty-5">y</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">3, Floating-point c# data type</h2>
<p className="mt-4 para"> 1, In Floating point data types groups, includes float and double and this show number with a fraction.<br/>
2, These floating-point numbers is a real number<br/>
 <span className="bold">Floating-point are 2 Data types:<br/>1, float <br/>2, double </span><br/>
*double bits is 64<br/>
*float bits is 32<br/>
</p>

<p className="mt-4 para">
<span className="bold">A, In float c# data type:</span><br/>
1, float specifies a single-precision value means uses 32bits of storage. <br/>
2, this float is slower than double precision but it takes half as much space as double-precision <br/>
3, the float stores a fractional number from 3.4e−038 to 3.4e+038.<br/>
4, float use for representing dollar and cents<br/>
5, you don’t store float value inside float data type if you type float data type so you also write small f like "f" after number end. <br/>
</p>



<h2 className='headings'>Float c# data types Example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">float </span>
            <span className="qwerty-5">number</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">40.56f;</span>
            {"\n"}
            <span className="qwerty-2">Console</span>
            <span className="qwerty-3">.WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-7">number</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">40.56</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<p className="mt-4 para">
<span className="bold">B, In Double c# data type:<br/></span>
1, double specifies a double-precision value means uses 64 bits of storage.<br/> 
2, double precision is faster than single precision<br/>
3, the double stores' fractional number 1.7e−308 to 1.7e+308<br/>
4, you don’t store the double value inside double data type if you type double data type so you also write small d like "d" after number end.<br/>
</p>


<h2 className='headings'>Double c# data types Example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">double </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">12.426d</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">Or </span>
            {"\n"}
            <span className="qwerty-6">Double </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">A</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">12.426d</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Console </span>
            <span className="qwerty-7">.WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">12.426</span>
            {"\n"}{"\n"}
          </code>
        </pre>
        </div>
      

<h2 className="mt-4 ">4, Bool c# data type:</h2>

<p className="mt-4 para">
<span className="bold para">In Bool c# data type: </span>
In the Boolean c# data type group include Boolean and this shows only true or false values and using the reserved word true and false.
</p>


<h2 className='headings'>Bool c# data types Example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">int </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">8</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Boolean </span>
            <span className="qwerty-5">c</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-4">&#60; </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Console </span>
            <span className="qwerty-2">.WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-4">true</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/csharp-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csdatatype;